/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Nav_Coach_AppInputs */

const en_portal_nav_coach_app = /** @type {(inputs: Portal_Nav_Coach_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I'm a coach`)
};

const pl_portal_nav_coach_app = /** @type {(inputs: Portal_Nav_Coach_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jestem trenerem`)
};

/**
* | output |
* | --- |
* | "I'm a coach" |
*
* @param {Portal_Nav_Coach_AppInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_nav_coach_app = /** @type {((inputs?: Portal_Nav_Coach_AppInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Nav_Coach_AppInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_nav_coach_app(inputs)
	return en_portal_nav_coach_app(inputs)
});